import Vue from 'vue';

import Vuetify from 'vuetify';

import '@fortawesome/fontawesome-free/css/all.css';
import en from 'vuetify/es5/locale/en';
import es from 'vuetify/es5/locale/es';
import {ColorUtils} from "../comunes/helpers/ColorUtils";

Vue.use(Vuetify);

const color = typeof process.env.MIX_COLOR == "undefined" ? "#ac598c" : process.env.MIX_COLOR;
const colorDark = ColorUtils.aclararOscurecerColor(color, -25);
const colorAccentLight = typeof process.env.MIX_COLOR_ACCENT_LIGTH == "undefined"
    ? ColorUtils.modificarColor(color, 20, 10, 50) : process.env.MIX_COLOR_ACCENT_LIGTH;
const colorAccentDark = typeof process.env.MIX_COLOR_ACCENT_DARK == "undefined"
    ? ColorUtils.modificarColor(colorDark, 0, -10, -50) : process.env.MIX_COLOR_ACCENT_DARK;

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    lang: {
        locales: {en, es},
        current: 'es'
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: color,
                secondary: '#ffffff',
                accent: colorAccentLight
            },
        },
    }
});
